import React, { useCallback, useContext } from 'react';

import { FirmsContext } from '../../firm.context';
import FirmForm from '../form';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(FirmsContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <FirmForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
